import MaterialGrid from "../../../../__snowpack__/pkg/@mui/material/Grid.js";
import styled from "styled-components";
export const MergeQueueGridContainer = styled(MaterialGrid).withConfig({
  displayName: "merge-queue-cardstyles__MergeQueueGridContainer",
  componentId: "sc-12qkagc-0"
})([".MuiPaper-root{", "}"], {
  height: "100%"
});
export const MergeQueueCardContainer = styled.div.withConfig({
  displayName: "merge-queue-cardstyles__MergeQueueCardContainer",
  componentId: "sc-12qkagc-1"
})(["", " > .MuiIcon-root{", "}"], {
  display: "flex",
  flexDirection: "column",
  padding: "0.5rem",
  height: "100%"
}, {
  alignSelf: "flex-end"
});
